import style from './LuckyEmptyCardsList.css';
import Button from '../../shared/Button/Button';
import useTranslation from '../../../localization/i18n.context';
import NavigationUtils from '../../../utils/navigation.utils';
import AddCardBackground from '../../../assets/images/add-cards.webp';
import VisaLogo from '../../../clients/cards/visa.webp';
import { DeeplinkEvent } from '../../../sdk/deeplink.event';
import { TrackingEvent } from '../../../sdk/tracking.event';

export default function LuckyEmptyCardsList({
  className = '',
  isLoggedIn = false,
}) {
  const { t } = useTranslation();
  return (
    <div className={`${className} ${style.banner}`}>
      <div className={style.content}>
        <h1 className={style.title}>
          {t('Empower yourself with a debit card today')}
        </h1>
        <p className={style.subtitle}>{t('Apply now and get your card')}</p>
      </div>
      <div className={style['button-group']}>
        <Button
          type={Button.Type.SECONDARY}
          onClick={() => {
            TrackingEvent.trigger(
              TrackingEvent.Events.DISCOVER_TAP_ACTION,
              TrackingEvent.Sources.CAAS,
              { source: 'add_card' },
            );
            const url = `${NavigationUtils.Routes.ADD_CARD}?source=${NavigationUtils.Sources.HOME}`;

            if (isLoggedIn) {
              DeeplinkEvent.openWebview(url);
            } else {
              DeeplinkEvent.loginAndRedirect(url);
            }
          }}
        >
          {t('Add Cards')}
        </Button>

        <img src={VisaLogo} width={40} />
      </div>

      <img src={AddCardBackground} height={184} className={style['card-bg']} />
    </div>
  );
}
